module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_004.png
// module id = 927
// module chunks = 0